import { Component, OnInit } from '@angular/core';
import { FunctionsService } from '../../services/functions.service';
import { UsersService } from '../../services/users.service';
import { Router } from '@angular/router';
import { HttpService } from '../../services/http.service';
import Swal from 'sweetalert2';
import { Consultants } from '../../models/consultants.model';

@Component({
  selector: 'app-consultant-list',
  templateUrl: './consultant-list.component.html',
  styleUrls: ['./consultant-list.component.scss']
})
export class ConsultantListComponent implements OnInit {

  isLoading: boolean = false;
  userType: any;
  produits: any = '';
  produitList: any[] = [];
  expertises: any = '';
  expertiseList: any[] = [];
  country: any = '';
  countryList: any[] = [];
  consultantsList: any[] = [];
  consultantSelected: Consultants[] = [];
  candidateIDSelected: any[] = [];
  daily_fee: any = '';
  nb_mission: any = '';
  
  constructor(public functionsService: FunctionsService, private usersService: UsersService, private router: Router, private httpService: HttpService) {
    this.userType = this.usersService.getUserType();
    
    if (this.userType != 'admin') {
      this.router.navigate(['/not-found']);
    }
  }

  ngOnInit(): void {
    localStorage.removeItem('profile-consultant');
    this.loadCountries();
    this.produitList = this.functionsService.getProduitsList();
    this.expertiseList = this.functionsService.getExpertiseList();
    this.searchConsultants();
  }

  exportToExcel() {

    if (this.consultantSelected.length == 0) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Veuillez sélectionner au moins une ligne.',
      });
    } else {
      this.isLoading = true;

      this.httpService.generateToExcel('consultant', this.candidateIDSelected.toString(), null).subscribe(
        (response: any) => {
          if (response.status == "success") {
            let filepath = response.data;

            this.isLoading = false;
            Swal.fire({
              icon: 'success',
              title: 'Excellent !',
              text: 'Votre fichier est à présent disponible.',
              confirmButtonText: 'Télécharger'
            }).then(() => {
              window.open(filepath, "", "width=300, height=300");
            });
          }
        },
        (error) => {
          this.isLoading = false;
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Vérifier votre connexion puis réessayée.',
          });
        }
      );
    }

  }

  calculateAge(dateBirth: any) {
    const currentDate = new Date().getTime();
    const dateOfBirth = new Date(dateBirth).getTime();
    const age = (currentDate - dateOfBirth) / (365 * 24 * 60 * 60 * 1000);

    return (isNaN(Math.floor(age))) ? '-' : Math.floor(age);
  }

  getConsultantProfile(consultantID: number) {
    const consultant = this.findConsultant(consultantID);
    if (consultant != null) {
      localStorage.setItem('back-url', '/tous-les-consultants');
      localStorage.setItem('profile-consultant', JSON.stringify(consultant));
      this.router.navigate(['profile-consultant', consultantID]);
    }
  }

  loadCountries() {
    this.httpService.getCountries().subscribe(data => {
      const countries: any = data;
      let countryList: any[] = [];
      countries.find((item: { country: any; }) => {
        const country = item.country
        if (!countryList.includes(country)) {
          countryList.push(country)
        }
      });

      this.countryList = countryList.sort();
    })
  }

  searchConsultants() {
    this.isLoading = true;
    let form = {
      produits: this.produits,
      expertises: this.expertises,
      country: this.country,
      daily_fee: this.daily_fee,
      nb_mission: this.nb_mission
    };

    this.httpService.searchConsultant(form).subscribe(
      (response: any) => {
        if (response.status == "success") {
          localStorage.setItem('consultants', JSON.stringify(response.data.list));
          this.generateConsultantArrayObject(response.data.list);

          this.isLoading = false;
        }
      },
      (error) => {
        this.isLoading = false;
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Vérifier votre connexion puis réessayée.',
        });
      }
    );
  }

  selectedRow(id: any, source: any) {
    if (id == 'all') {
      let rowSelected: any = document.getElementById("checkbox_" + id);
      const rowChecked = (source == 'checkbox') ? !rowSelected.checked : rowSelected.checked
      if (rowChecked == false) {
        this.consultantSelected = [];
        this.consultantsList.forEach((consultants: Consultants) => {
          let currentRow: any = document.getElementById("checkbox_" + consultants.getId());
          currentRow.checked = true;
          this.addInConsultantSelectedList(consultants);
        });
      } else {
        this.consultantsList.forEach((consultants: Consultants) => {
          let currentRow: any = document.getElementById("checkbox_" + consultants.getId());
          currentRow.checked = false;
          this.consultantSelected = [];
        });
      }
    } else {
      let rowSelected: any = document.getElementById("checkbox_" + id);
      const rowChecked = rowSelected.checked
      if (rowChecked == false) {
        this.addInConsultantSelectedList(this.findConsultant(id));
        rowSelected.checked = true;
      } else {
        this.removeInConsultantSelectedList(this.findConsultant(id));
        rowSelected.checked = false;
      }
    }
  }

  addInConsultantSelectedList(consultantToAdd: Consultants) {
    const list = this.consultantSelected;
    let inList = false;

    for (let index = 0; index < list.length; index++) {
      const consultants: Consultants = list[index];

      if (consultantToAdd.getId() == consultants.getId()) {
        inList = true;
        break;
      }
    }

    if (!inList) {
      this.consultantSelected.push(consultantToAdd);
      this.candidateIDSelected.push(consultantToAdd.getId());
    }
  }

  removeInConsultantSelectedList(consultantToRemove: Consultants) {
    const list = this.consultantSelected;
    let indexOfConsultant = -1;

    for (let index = 0; index < list.length; index++) {
      const consultants: Consultants = list[index];

      if (consultantToRemove.getId() == consultants.getId()) {
        indexOfConsultant = index;
        break;
      }
    }

    if (indexOfConsultant != -1) {
      this.consultantSelected.splice(indexOfConsultant, 1);
      this.candidateIDSelected.splice(indexOfConsultant, 1);
    }
  }

  findConsultant(consultantID: number): Consultants {
    for (let index = 0; index < this.consultantsList.length; index++) {
      const consultant = this.consultantsList[index];

      if (consultant.getId() == consultantID) {
        return consultant;
      }

    }

    return new Consultants({});

  }

  generateConsultantArrayObject(list: []) {
    this.consultantsList = [];
    list.forEach(element => {
      const consultants = new Consultants(element);
      this.consultantsList.push(consultants);
    });
  }

}
